import * as React from 'react';

import { InjectedRouter } from 'react-router';

import { withRouter } from 'app/context/Router';
import Box from 'components/Box';
import BoxBody from 'components/BoxBody';
import BoxFooter from 'components/BoxFooter';
import Container from 'components/Container';
import TitleHeader from 'components/TitleHeader';
import TosText from 'components/TosText';
// @ts-ignore
import View from 'components/View';
import EventTracking from 'lib/EventTracking';
import PasswordForm from 'user/components/PasswordForm';

type Props = {
  router: InjectedRouter;
  location: any;
};

type State = {
  onDeviceConfirmation: boolean;
};

class SetupPassword extends React.Component<Props, State> {
  state = {
    onDeviceConfirmation: false,
  };

  handleSave = () => {
    this.props.router.push(this.props.location?.state?.location ?? '/classes');
    EventTracking.trackKey('tos_and_pp.view');
  };

  handleDeviceConfirmation = () => {
    this.setState({ onDeviceConfirmation: true });
  };

  render() {
    const { onDeviceConfirmation } = this.state;
    const title = onDeviceConfirmation ? '' : 'Create a password';
    const subtext = onDeviceConfirmation
      ? ''
      : 'Passwords need to be at least six characters long.';

    return (
      <Box title={title} subtext={subtext} size="small">
        <BoxBody>
          <PasswordForm
            onSave={this.handleSave}
            onNeedsDeviceConfirmation={this.handleDeviceConfirmation}
          />
        </BoxBody>
        <BoxFooter>
          <TosText />
        </BoxFooter>
      </Box>
    );
  }
}

export { SetupPassword };
export default withRouter(SetupPassword);
